import { Pipe, PipeTransform } from "@angular/core";


@Pipe({ name: 'formatPercent' })
export class FormatPercentPipe implements PipeTransform {
    transform(value: string): string {
        const splitValue = value.indexOf('.') > 0 && value.split('.')
        const newValue = splitValue[1] == '00' ? splitValue[0] : value.replace('.', ',')
        return newValue.concat('%');
    }
}